module.exports = __webpack_public_path__ + "img/85duC.bcda491d.png";